import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Homeone from '../../components/Homeone/Homeone'


const Home = () => {
  return (
    <>
    <Navbar />
    <Homeone />
    <Footer />
    </>
  )
}

export default Home